import apiClient from '../api/apiClient';

// 스터디 카테고리 관련 타입 정의
export interface StudyCategory {
  id: number;
  name: string;
  slug: string;
  sort_order: number;
  post_count: number;
}

export interface StudyCategoryRequest {
  name: string;
  slug: string;
  sortOrder: number;
}

export interface StudyCategoryApiResponse<T> {
  code: number;
  status: string;
  message: string;
  data: T;
}

// 스터디 카테고리 목록 조회
export const getStudyCategoriesList = async (): Promise<StudyCategoryApiResponse<StudyCategory[]>> => {
  try {
    /// console.log('관리자 스터디 카테고리 목록 조회 API 호출');
    
    const { data: result } = await apiClient.get<StudyCategoryApiResponse<StudyCategory[]>>(
      '/api/admin/study-categories/list',
      { withCredentials: true }
    );
    
    /// console.log('관리자 스터디 카테고리 API 응답:', {result});
    
    return result;
  } catch (error) {
    /// console.error('관리자 스터디 카테고리 목록 조회 실패:', error);
    throw error;
  }
};

// 스터디 카테고리 생성
export const createStudyCategory = async (request: StudyCategoryRequest): Promise<StudyCategoryApiResponse<StudyCategory>> => {
  try {
    /// console.log('스터디 카테고리 생성 API 호출:', request);
    
    const { data: result } = await apiClient.post<StudyCategoryApiResponse<StudyCategory>>(
      '/api/admin/study-categories',
      request,
      { withCredentials: true }
    );
    
    /// console.log('스터디 카테고리 생성 API 응답:', {result});
    
    return result;
  } catch (error) {
    /// console.error('스터디 카테고리 생성 실패:', error);
    throw error;
  }
};

// 스터디 카테고리 수정
export const updateStudyCategory = async (id: number, request: StudyCategoryRequest): Promise<StudyCategoryApiResponse<StudyCategory>> => {
  try {
    /// console.log('스터디 카테고리 수정 API 호출:', id, request);
    
    const { data: result } = await apiClient.put<StudyCategoryApiResponse<StudyCategory>>(
      `/api/admin/study-categories/${id}`,
      request,
      { withCredentials: true }
    );
    
    /// console.log('스터디 카테고리 수정 API 응답:', {result});
    
    return result;
  } catch (error) {
    /// console.error('스터디 카테고리 수정 실패:', error);
    throw error;
  }
};

// 스터디 카테고리 삭제 (게시글이 있는 경우 targetCategoryId로 이동)
export const deleteStudyCategory = async (id: number, targetCategoryId?: number): Promise<StudyCategoryApiResponse<{}>> => {
  try {
    const { data: result } = await apiClient.delete<StudyCategoryApiResponse<{}>>(
      `/api/admin/study-categories/${id}`,
      {
        withCredentials: true,
        params: targetCategoryId ? { targetCategoryId } : undefined,
      }
    );
    return result;
  } catch (error) {
    throw error;
  }
};
